import { render, staticRenderFns } from "./layout-category-products.vue?vue&type=template&id=69632d54&scoped=true"
import script from "./layout-category-products.vue?vue&type=script&lang=js"
export * from "./layout-category-products.vue?vue&type=script&lang=js"
import style0 from "./layout-category-products.vue?vue&type=style&index=0&id=69632d54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69632d54",
  null
  
)

export default component.exports